const levels = {
  trace: 0,
  log: 1,
  warn: 2,
  error: 3,
} as const

type Levels = keyof typeof levels

type Logger = Record<Levels, (...args: any) => void>

const isLevelMet = (configLevel: number | Levels, target: Levels) => {
  const current =
    typeof configLevel === 'number' ? configLevel : levels[configLevel]
  const targetLevel = levels[target]
  if (targetLevel == null) {
    return false
  }
  return targetLevel >= current
}

const getLogger = (tag: string, level: number | Levels): Logger => {
  const keys = Object.keys(levels) as Array<Levels>

  const entries = keys.map((key) => [
    key,
    (...args: any) => {
      if (!isLevelMet(level, key)) {
        return
      }
      console[key](`[${tag}]`, ...args)
    },
  ])

  return Object.fromEntries(entries)
}

export default getLogger
